import { theme } from '@approvalmax/theme';
import { font, oPopupPaddingBottom, uTextEllipsis } from 'modules/styles';
import styled from 'styled-components';

export const Root = styled.div`
    width: 100%;
    height: 100%;
    padding: 20px 60px 40px 60px;
    display: flex;
    flex-flow: column;

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        padding: 0;
    }
`;

export const Title = styled.div`
    ${font(13, '#000', 'bold')}
    margin-bottom: 5px;
`;

export const Description = styled.div`
    ${font(12, '#5e5c5c')}
    margin-bottom: 18px;
`;

export const List = styled.ul`
    display: flex;
    flex-flow: column;
`;

export const InvitationItem = styled.li`
    display: flex;
    align-items: center;
    height: 76px;

    &:not(:last-child) {
        ${oPopupPaddingBottom()}
    }

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        flex: none;
        height: auto;
        margin-bottom: 30px;

        &:not(:last-child) {
            padding-bottom: 0;
        }
    }
`;

export const InvitationLeft = styled.div`
    flex: 1;
    display: flex;
    flex-flow: column;
`;

export const InvitationTitle = styled.div`
    ${font(16, '#30373d', 'semibold')}
    ${uTextEllipsis}

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        ${font(15, '#000', 'semibold')}
    }
`;

export const InvitationNote = styled.div`
    ${font(13, '#000')}
    ${uTextEllipsis}

    @media (max-width: ${theme.container.breakpoint.xsmall}) {
        ${font(12, '#777d81', 'semibold')}
    }
`;

export const InvitationRight = styled.div`
    font-weight: 600;
`;
